import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';
import { translatedRoutes } from './routes';
import { defaultLocale, locales, localePrefix } from './config';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales,
  // Used when no locale matches
  defaultLocale,
  localeDetection: true,
  // add prefix even with default locale
  localePrefix,
  pathnames: translatedRoutes,
});

/*
 * Lightweight wrappers around Next.js' navigation APIs
 * that will consider the routing configuration
 */
export const {
  Link, redirect, usePathname, useRouter,
} = createNavigation(routing);
